import { render, staticRenderFns } from "./GrantTrend.vue?vue&type=template&id=5cdf6151"
import script from "./GrantTrend.vue?vue&type=script&lang=js"
export * from "./GrantTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports